import apiCore from "services/apiCore";

export default {
    getProtectionStatus: function (conversationId) {
        return apiCore.v2.post("/recordings/deletionprotection", {
            conversationIds: [conversationId],
        });
    },

    updateProtectionStatus: function (conversationId, protect) {
        return apiCore.v2.put(
            "/recordings/deletionprotection",
            { conversationIds: [conversationId] },
            { protect: protect }
        );
    },
};
